<div id="settings">
    <div id="entries">
        <h1 class="settings-entry">Settings</h1>
        <!-- Filled by javascript -->
    </div>
</div>